import {Image} from '@primer/react-brand/esm'

import type {Asset} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'
import {MAX_CONTENT_WIDTH, getImageSources} from '@github-ui/swp-core/lib/utils/images'

import {getAssetImageStyle} from '../../utils'
import type {AssetItemPosition} from '../../types'
import {HeroCarouselMediaFrame} from './HeroCarouselMediaFrame'
import styles from './FlexSuiteHeroCarousel.module.css'

export function HeroCarouselImage({
  image,
  position,
  isActive,
}: {
  image: Asset
  position: AssetItemPosition
  isActive: boolean
}) {
  const imageStyle = getAssetImageStyle(image)
  const dimensions = image.fields.file.details?.image
  return (
    <HeroCarouselMediaFrame imagePosition={position} isActive={isActive}>
      <Image
        as="picture"
        className={styles.Image}
        aspectRatio={imageStyle ? 'custom' : undefined}
        style={imageStyle}
        width={dimensions?.width}
        height={dimensions?.height}
        src={`${image.fields.file.url}?fm=webp`}
        sources={getImageSources(image.fields.file.url, {
          maxWidth: MAX_CONTENT_WIDTH,
          disableDprScaling: true,
        })}
        alt={image.fields.description ?? ''}
      />
    </HeroCarouselMediaFrame>
  )
}
